import { createSelector } from "reselect";

export const getFaturamentoState = (state) => state.faturamento;

export const getFaturamentos = createSelector(
  getFaturamentoState,
  (state) => state.faturamentos
);
